import { schema } from 'normalizr'

// Schemas
import { collectionListSchema } from 'modules/collections/models'
import { artistSchema, artistListSchema } from 'modules/artists/models'
import { labelSchema, labelListSchema } from 'modules/labels/models'

export const download = new schema.Entity('downloads')
export const downloadList = [download]

export const searchQuery = new schema.Entity('searchquery')
export const searchQueryList = [searchQuery]

export const region = new schema.Entity('regions')
export const regionList = [region]

export const notification = new schema.Entity('notifications')
export const notificationList = [notification]

export const trackType = new schema.Entity('trackTypes')
export const trackTypeList = [trackType]

export const licenseRevenue = new schema.Entity('licenseRevenues')
export const licenseRevenueList = [licenseRevenue]

export const downloadlink = new schema.Entity('downloadlinks')

export const genre = new schema.Entity('genres')
genre.define({
  parent: genre,
  children: [genre],
})
export const genreList = [genre]

export const song = new schema.Entity('songs', {
  regions: [region],
  genres: [genre],
  types: [trackType],
  labels: [labelSchema],
  artists: [artistSchema],
})
export const songList = [song]

export const track = new schema.Entity('tracks', {
  song,
  types: [trackType],
})
export const trackList = [track]

export const searchData = new schema.Entity('searchData', {
  genres: genreList,
  regions: regionList,
  track_types: trackTypeList,
  labels: labelListSchema,
})

export const licenserequest = new schema.Entity('licenses', {
  song,
})
export const licenserequestList = [licenserequest]

export const licenseType = new schema.Entity('licenseTypes', {
  revenue_set: licenseRevenueList,
})

export const licenseTypeList = [licenseType]

export const searchresult = new schema.Entity('tracks', {
  songs: songList,
  regions: regionList,
  genres: genreList,
  labels: labelListSchema,
  types: trackTypeList,
})
export const searchresultList = [searchresult]

export const user = new schema.Entity('users', {
  collections: collectionListSchema,
})
export const userList = [user]

const recommendations = {
  tracks: trackList,
  artists: artistListSchema,
  collections: collectionListSchema,
}

export const recommendationsSong = new schema.Entity('recommendationsSong', recommendations)
export const recommendationsArtist = new schema.Entity('recommendationsArtist', recommendations)
export const recommendationsCollection = new schema.Entity('recommendationsCollection', recommendations)
export const recommendationsTop = new schema.Entity('recommendationsTop', recommendations)
